<template>
 <div>
    <b-form>
      <div class="login-container">
        <!-- 箭頭指示和文字提示 -->
        <div class="click-indicator">
          <div class="arrow-down"></div>
          <span class="click-text">請點選</span>
        </div>
        
        <!-- LINE 登入按鈕 -->
        <b-button type="button" variant="link" @click="linelogin" class="line-login-btn">  
          <img alt="Vue logo" src="../assets/lineloginnew.png" class="line-login-img">
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex';
export default {
  name: 'Linelogin',
  data() {
    return {
        errors:'',
        mtyps:'error',
        display:false,
    };
  },
  methods: {
    ...mapActions('account',['login']),

    linelogin(){
      //window.location=process.env.VUE_APP_URL +'gotoauthOpenIDpage'
      let target = 'Home'  
      if(this.targetpage){
        target = this.targetpage
      }
      let  temp_form = document.createElement("form");
           temp_form.action = process.env.VUE_APP_URL +'gotoauthOpenIDpage';
           //temp_form.action = process.env.VUE_APP_URL +'gotoauthpage'; 
           temp_form.target = "_self";
           temp_form.method = "post";      
           temp_form.style.display = "none";
      let  opt = document.createElement("input"); 
           opt.type = "text";
           opt.name = "chatbot";
           opt.value = target
           temp_form.appendChild(opt);    
           document.body.appendChild(temp_form);
           // 提交表單      
           temp_form.submit();   
    },

  },
    computed: {
      ...mapState('account',['status','targetpage']),
    },


};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
}

.click-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  animation: bounce 2s infinite;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 18px solid transparent;
  border-right: 18px solid transparent;
  border-top: 22px solid #00C300;
  margin-bottom: 8px;
  animation: arrowPulse 1.5s ease-in-out infinite;
}

.click-text {
  font-size: 22px;
  font-weight: 600;
  color: #00C300;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.5px;
  animation: textGlow 2s ease-in-out infinite alternate;
}

.line-login-btn {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 195, 0, 0.2);
  background: transparent;
  border: none;
  padding: 0;
}

.line-login-btn:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 8px 25px rgba(0, 195, 0, 0.3);
}

.line-login-btn:active {
  transform: translateY(-1px) scale(1.02);
  box-shadow: 0 4px 15px rgba(0, 195, 0, 0.4);
}

.line-login-img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.line-login-btn:hover .line-login-img {
  filter: brightness(1.1) saturate(1.1);
}

/* 動畫效果 */
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-8px);
  }
  60% {
    transform: translateY(-4px);
  }
}

@keyframes arrowPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

@keyframes textGlow {
  from {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  to {
    text-shadow: 0 1px 8px rgba(0, 195, 0, 0.3), 0 0 12px rgba(0, 195, 0, 0.2);
  }
}

/* 響應式設計 */
@media (max-width: 768px) {
  .login-container {
    padding: 15px;
  }
  
  .arrow-down {
    border-left-width: 15px;
    border-right-width: 15px;
    border-top-width: 18px;
  }
  
  .click-text {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 10px;
  }
  
  .click-indicator {
    margin-bottom: 12px;
  }
  
  .arrow-down {
    border-left-width: 12px;
    border-right-width: 12px;
    border-top-width: 15px;
    margin-bottom: 6px;
  }
  
  .click-text {
    font-size: 16px;
  }
  
  .line-login-btn:hover {
    transform: translateY(-2px) scale(1.03);
  }
}
</style>